import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, TextInput, showErrorToast } from '@ui';
import I18n, { translate } from '@utils/i18n';
import api from '@utils/axios';
import { sendWoEmailWorkOrdersPath } from '@routes';
import './SendWorkOrderModalStyles.scss';
const namespace = 'features.work_orders.send_email';
const FORM_ID = 'work-order-send-form';
export default function SendWorkOrderModalView({ workOrderId, sendToEmails, subject, body, footer, pdfPath, isOpen, onClose, onSent }) {
    const [loading, setLoading] = useState(false);
    const [sendToEmail, setSendToEmail] = useState(sendToEmails !== null && sendToEmails !== void 0 ? sendToEmails : '');
    const [emailSubject, setEmailSubject] = useState(subject !== null && subject !== void 0 ? subject : '');
    const [emailBody, setEmailBody] = useState(body !== null && body !== void 0 ? body : '');
    const [emailFooter, setEmailFooter] = useState(footer !== null && footer !== void 0 ? footer : '');
    const isValid = sendToEmail.trim().length > 0 && emailSubject.trim().length > 0;
    const onSubmit = () => {
        if (!isValid || loading)
            return;
        setLoading(true);
        const payload = new FormData();
        payload.append('work_order_id', String(workOrderId));
        payload.append('send_to_emails', sendToEmail);
        payload.append('email_subject', emailSubject);
        payload.append('email_body', emailBody);
        payload.append('email_footer', emailFooter);
        api
            .post(sendWoEmailWorkOrdersPath({ format: 'json' }), payload)
            .then(({ data }) => {
            onSent === null || onSent === void 0 ? void 0 : onSent(data.message);
            onClose();
        })
            .catch((error) => {
            var _a, _b, _c;
            showErrorToast((_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : String(I18n.t('generic.errors.request_error')));
        })
            .finally(() => setLoading(false));
    };
    const pdfPreview = pdfPath ? (React.createElement("div", { className: "sendWorkOrderModal__preview" },
        React.createElement("object", { data: pdfPath, type: "application/pdf", className: "sendWorkOrderModal__pdf" },
            React.createElement("p", null,
                React.createElement("a", { href: pdfPath, target: "_blank", rel: "noopener noreferrer" }, translate('pdf_viewer_not_supported', { namespace })))))) : null;
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, variant: "base", className: "sendWorkOrderModal", ariaLabel: translate('title', { namespace }) },
        React.createElement(ModalHeader, { title: translate('title', { namespace }), onClose: onClose }),
        React.createElement(ModalBody, { className: "sendWorkOrderModal__body", "data-testid": "send-work-order-modal-body" },
            React.createElement("form", { id: FORM_ID, className: "sendWorkOrderModal__form", "data-testid": "send-work-order-form", onSubmit: (e) => {
                    e.preventDefault();
                    onSubmit();
                } },
                React.createElement(TextInput, { id: "wo-send-email", type: "email", multiple: true, label: translate('send_to_email', { namespace }), required: true, value: sendToEmail, disabled: loading, onChange: (e) => setSendToEmail(e.target.value) }),
                React.createElement(TextInput, { id: "wo-send-subject", label: translate('subject', { namespace }), required: true, value: emailSubject, disabled: loading, onChange: (e) => setEmailSubject(e.target.value) }),
                React.createElement(TextInput, { id: "wo-send-body", multiline: true, rows: 8, label: translate('body', { namespace }), value: emailBody, disabled: loading, onChange: (e) => setEmailBody(e.target.value) }),
                React.createElement(TextInput, { id: "wo-send-footer", multiline: true, rows: 6, label: translate('footer', { namespace }), value: emailFooter, disabled: loading, onChange: (e) => setEmailFooter(e.target.value) })),
            pdfPreview),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { onClick: onClose, disabled: loading }, I18n.t('generic.cancel')),
            React.createElement(Button, { variant: "primary", type: "submit", form: FORM_ID, disabled: loading || !isValid, "data-testid": "send-work-order-submit" }, translate('send_and_close', { namespace })))));
}
